import { Fireworks } from 'fireworks-js';    


// Obtener el token de la URL
const urlParams = new URLSearchParams(window.location.search);
// El re-launcher del backend (/dev/relaunch y los marketers en prod) redirige con
// `?tok=`; se mantiene `?token=` como alias por compatibilidad.
const token = urlParams.get('tok') || urlParams.get('token');

const api = 'https://pam-quiniela-millonaria-staging.betnplayapp.com/api'
// const api = 'https://quiniela.microprueba.com/api'


function detailTicketGlobal(index, listItems){

    let html = `<div class="card-body" id="ticket-detail" style="background: black;">`;

    if(listItems[index].hits == 6 || listItems[index].hits == 5){
      
      html += `
        <div class="row bg-success text-white" style="margin-bottom: 20px; padding-top: 7px;">
          <div class="col-12 text-center">
            <h2>Ticket Ganador</h2>
          </div>
        </div>
      `;
    }

    html += `<h3 class="card-title">Jugadas</h3>`;
    html += `<div class="row" style="margin-bottom: 20px;">`;
    listItems[index].numbers.forEach((data) => {
      html+= `
        <div class='col-4'>
          <img class="img-modal-selected" src="./static/img/quinelanew/lottoactivo_`+String(data.number).padStart(2, '0')+`.webp" />
        </div>
      `;
    });
    html+= `</div></div>`;
  
    Swal.fire({
      html:`
        <div class="card" style="border: 0px;">
          <div class="card-body">
            <h5 class="card-title mb-0">
              <i class="dorado fa-solid fa-ticket"></i> Ticket <br/> <span class="dorado">${listItems[index].sorteo}</span>
            </h5>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><i class="dorado fa-solid fa-hashtag"></i> &nbsp; ${listItems[index].ticket_number}</li>
            <li class="list-group-item"><i class="dorado fa-solid fa-user"></i> &nbsp; ${listItems[index].user_name}</li>
            <li class="list-group-item bold"><i class="dorado fa-solid fa-money-bill"></i> &nbsp; ${listItems[index].amount} ${listItems[index].currency}</li>
            <li class="list-group-item"><i class="dorado fa-solid fa-calendar"></i> &nbsp; ${listItems[index].date_time}</li>
            <li class="list-group-item"><i class="dorado fa-solid fa-check"></i> &nbsp; Aciertos &nbsp; <span class="bold">${listItems[index].hits}</span></li>
          </ul>
          ${html}
          
        </div>
      `,
      confirmButtonText: 'Cerrar',
      showClass: {
        popup: `
        animate__animated
        animate__fadeInUp
        animate__faster
        `
      },
      hideClass: {
        popup: `
        animate__animated
        animate__fadeOutDown
        animate__faster
        `
      },
      customClass: {
        container: 'ticket-detail-modal'
      }
    });

    //Se debe cargar primero el modal
    if(listItems[index].hits == 6 || listItems[index].hits == 5){
        const container = document.querySelector(".ticket-detail-modal");
        animmateFireworks(container);
    }

}

function animmateFireworks(container){
    const fireworks = new Fireworks(container, {
      autoresize: true,
      opacity: 0.5,
      acceleration: 1.05,
      friction: 0.97,
      gravity: 1.5,
      particles: 50,
      traceLength: 3,
      traceSpeed: 10,
      explosion: 5,
      intensity: 30,
      flickering: 50,
      lineStyle: 'round',
      hue: {
        min: 0,
        max: 360
      },
      delay: {
        min: 10,
        max: 100
      },
      rocketsPoint: {
        min: 50,
        max: 50
      },
      lineWidth: {
        explosion: {
          min: 1,
          max: 3
        },
        trace: {
          min: 1,
          max: 2
        }
      },
      brightness: {
        min: 50,
        max: 80
      },
      decay: {
        min: 0.015,
        max: 0.03
      },
      mouse: {
        click: false,
        move: false,
        max: 1
      }
    });
    fireworks.start()
}

function cargarFecha(){
  // Obtener la fecha y hora actual
  var currentDate = new Date();
  // Obtener los componentes de la fecha
  var year = currentDate.getFullYear();
  // Agregar un cero delante si el mes es menor que 10
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  // Agregar un cero delante si el día es menor que 10
  var day = currentDate.getDate().toString().padStart(2, '0');
  // Formatear la fecha
  return `${year}-${month}-${day}`;
}

function cargarFechaYHora(){
  // Obtener la fecha y hora actual
  var currentDate = new Date();
  // Obtener los componentes de la fecha
  var year = currentDate.getFullYear();
  // Agregar un cero delante si el mes es menor que 10
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  // Agregar un cero delante si el día es menor que 10
  var day = currentDate.getDate().toString().padStart(2, '0');
  // Obtener los componentes de la hora
  var hours = currentDate.getHours().toString().padStart(2, '0');
  var minutes = currentDate.getMinutes().toString().padStart(2, '0');
  var seconds = currentDate.getSeconds().toString().padStart(2, '0');
  // Formatear la fecha y hora
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export { api, token, detailTicketGlobal, animmateFireworks, cargarFecha, cargarFechaYHora };

